import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Modal, Tabs } from 'antd'
import WrappedDocUpdate from '../UpdateDocument'


const DocumnetForm = (props) => {
  const { visible, onOk, onCancel, formData } = props

  return (
    <Modal
      destroyOnClose={true}
      title="Update Document"
      visible={visible}
      onCancel={onCancel}
      footer={null}>
      <Tabs type="card" defaultActiveKey="1">
        <Tabs.TabPane tab="Update Document" key="1">
          <WrappedDocUpdate
            onOk={onOk}
            onCancel={onCancel}
            formData={formData}
          />
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  )
}

DocumnetForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default DocumnetForm
